import React from 'react'
import { IconsProps } from 'msp-integrations'

const BluetoothIcon = (props: IconsProps) => {
  return (
    <svg
      {...props}
      version='1.1'
      id='Ebene_1'
      x='0px'
      y='0px'
      viewBox='0 0 141.73 141.73'
    >
      <path d="M68.43 114.29V74.41L40.68 92.94l-1.66-2.49L67.3 71.57 39.01 52.78l1.66-2.5 27.75 18.45V28.71l34.28 22.82-30 20.03 30.02 19.95-34.29 22.78zm3-39.98v34.39L97.3 91.5 71.43 74.31zm0-40v34.5L97.3 51.53 71.43 34.31z" />
    </svg>
  )
}

export default BluetoothIcon
